module.exports = __webpack_public_path__ + "img/monthly-payment-icon.67683dfa.svg";